import type { DividerBlock as DividerBlockType } from "@/canvas/types/blocks";

interface DividerBlockProps {
  block: DividerBlockType;
  /** Passed for consistency but unused - divider has no interactive/editable content */
  readOnly?: boolean;
}

/**
 * DividerBlock renders a simple horizontal line separator.
 *
 * Per CONTEXT.md decisions:
 * - Single style (no variants)
 * - With margin (horizontal padding)
 * - Fixed spacing (consistent top/bottom margin)
 * - Thin subtle line (light gray, matching design system)
 */
export function DividerBlock({ block, readOnly: _readOnly }: DividerBlockProps) {
  // block prop received for consistency with other blocks, but not used
  // since divider has no content
  void block;

  return (
    <div className="p-4">
      <div className="h-px w-full bg-border" />
    </div>
  );
}
